module.exports = __webpack_public_path__ + "static/mail-7b7e41cba070ede9a24520132b2b6147.png";